import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import Horizontal_Logo from '../../assets/images/horizontal-enterprise2.png'
import styles from './styles'
import { withStyles } from '@material-ui/core/styles'
import { Button, Typography } from '@material-ui/core'
import GhostShowing from '../../assets/images/ghostie_nocontacts.png'

class LandingPage extends React.Component {
  render() {
    const { classes } = this.props
    return (
      <div className={classes.background}>
        <div className={classes.wrapper}>
          <img
            src={Horizontal_Logo}
            className={classes.logo}
            alt="horizontal-logo"
          />
          <img
            src={GhostShowing}
            className={classes.logo}
            alt="showing-ghost"
          />
          <Typography className={classes.text} variant="h6">
          Welcome to FaceSnap Enterprise!
          </Typography>
          <Button
            variant="contained"
            // color="secondary"
            style={{ color: 'rgba(237,67,106,1)', backgroundColor: '#fff' }}
            className={classes.button}
            onClick={() => this.props.history.push('/facesnap/register')}
          >
            Register Here
          </Button>
          {/* CopyRight */}
          <div className={this.props.classes.copyRight}>
            <Typography
              className={this.props.classes.copyRightText}
              variant="caption"
            >
              Copyright &copy; {new Date().getFullYear()} SafeShowings
            </Typography>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  authentication: state.authentication
})

export default compose(
  connect(mapStateToProps),
  withStyles(styles, {
    withTheme: true
  })
)(LandingPage)
